import { render, staticRenderFns } from "./index-web.vue?vue&type=template&id=9a77c0cc&scoped=true"
import script from "./index-web.vue?vue&type=script&lang=ts"
export * from "./index-web.vue?vue&type=script&lang=ts"
import style0 from "./index-web.vue?vue&type=style&index=0&id=9a77c0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a77c0cc",
  null
  
)

export default component.exports